import { atom, swr } from '@exodus/headless-ui';
import quoteAtom from './quote.js';
import fromAmountAtom from './from-amount.js';
import { preventFromExchangingAtom } from './error.js';
import configAtom from './config.js';
import { isExpired } from '../helpers/is-expired.js';
const canExchangeAtom = atom((get) => {
    const quoteState = get(swr(quoteAtom));
    const fromAmount = get(fromAmountAtom);
    const preventFromExchanging = get(preventFromExchangingAtom);
    const { expiryMarginMs } = get(configAtom);
    const quote = quoteState.data;
    if (!quote || !fromAmount.isPositive || preventFromExchanging) {
        return false;
    }
    return !isExpired(quote.expiry, expiryMarginMs);
});
export default canExchangeAtom;
